import moment from 'moment';

export default {
  props: {
    roomDateFormat: {
      type: String,
      default: 'hh:mm',
      required: false,
    }
  },
  data() {
    return {
      imageGallery: false,
      giftGallery: false,
      textMessages: {
        CONVERSATION_STARTED: this.trans.get('pages:chat.conversation_started'),
        TYPE_MESSAGE: this.trans.get('pages:chat.type_message_placeholder'),
        SEARCH: this.trans.get('pages:chat.search_placeholder'),
        UNBLOCK_MEMBER: this.trans.get('pages:chat.unlock_member'),
        IS_ONLINE: this.trans.get('pages:chat.is_online'),
        LAST_SEEN: this.trans.get('pages:chat.last_seen'),
        NEW_MESSAGES: this.trans.get('pages:chat.new_messages'),
        MESSAGE_DELETED: this.trans.get('pages:chat.message_deleted'),
        MESSAGES_EMPTY: this.trans.get('pages:chat.messages_empty'),
      },
      chatWindowStatus: {
        showRoomsList: true,
        isMobile: false,
        fullWidth: false,
      },
      isMobile: false
    };
  },
  computed: {
    menuActions: function () {
      let actions = [];

      if (this.activeRoom) {
        let profile = this.activeRoom.profile;
        if (!profile.is_admin) {
          if (profile.is_blurred_avatar === false) {
            actions.push({ name: 'viewProfile', title: this.trans.get('pages:chat.action_menu.view_profile') });
          }
          if (!this.activeRoom.is_blocked) {
            actions.push({ name: 'blockOrReport', title: this.trans.get('pages:chat.action_menu.block_or_report') });
          }
        }
        actions.push({ name: 'deleteChatHistory', title: this.trans.get('pages:chat.action_menu.delete_chat_history') });
      }

      return actions;
    },
    priceByMessage() {
      return window.globals.settings_payment_chat_message;
    },
  },
  watch: {},
  methods: {
    closeRoom() {
      console.log(this.profileId);
      if (this.profileId && this.$store.getters['router/getPrevName'] === 'profile') {
        this.$router.back();
      }
    },
    buyMedia({ media, message }) {
      axios
        .post(zRoute('ajax.profiles.media.store'), {
          media_id: media.id,
          message_id: message.id,
        })
        .then(response => {
          this.mediaUpdate(response.data.data);
        });
    },
    mediaUpdate(media) {
      this.messages.forEach((m) => {
        if (m.media && (m.media.id === media.id)) {
          m.media = media;
        }
      });
    },
    menuActionHandler({ action, roomId, profileId }) {
      // const profileId = this.activeRoom.profile_id;

      if (action.name === 'viewProfile') {
        this.$router.push({ name: 'profile', params: { id: profileId } });
      } else if (action.name === 'blockOrReport') {
        this.$eventHub.$emit('ReportModalOpen', profileId);
      } else if (action.name === 'deleteChatHistory') {
        $('#chatDeleteModal').modal('show');
      }
    },
    unBlockMember({ roomId, profileId }) {
      if (roomId) {
        axios
          .post(zRoute('ajax.violations.destroy', {
            profile: roomId,
          }))
          .then(response => {
            // this.getRoomsDebounced('ViolationDestroy');
            this.fetchMessages({ room: this.activeRoom, options: { reset: true } });
            this.getRoom(roomId, 'ViolationDestroy');
          });
      } else {
        axios
          .post(zRoute('ajax.more_settings.blocked_members.remove', {
            profile: profileId
          }))
          .then((response) => {
            this.createRoomByProfileId(profileId)
              .then((room) => {
                if (this.activeRoom && this.activeRoom.profile_id === profileId) {
                  this.chatSetActiveRoom(room);
                }
              });
          });
      }
    },
    formatRoomDate: function (value) {
      let date = moment(String(value));
      let d = new Date();
      const hourFormat = this.roomDateFormat || 'hh:mm';

      if (date.isSame(d, 'day')) {
        return date.format(hourFormat);
      }

      if (date.isSame(d.setDate(d.getDate() - 1), 'day')) {
        return this.trans.get('pages:chat.yesterday') + ' ' + date.format(hourFormat);
      }

      if (date.isSame(d.setDate(d.getDate() - 1), 'day')) {
        return this.trans.get('pages:chat.2_days_ago') + ' ' + date.format(hourFormat);
      }

      return date.format('DD.MM.YYYY ' + hourFormat);
    },
    windowStatus: function (status) {
      this.$store.commit('chat/setShowRoomsList', status.showRoomsList);

      this.chatWindowStatus.showRoomsList = status.showRoomsList;
      this.chatWindowStatus.isMobile = status.isMobile;
      this.chatWindowStatus.fullWidth = !(status.showRoomsList === true && status.isMobile === false);
    },
    toggleImageGallery: function () {
      this.imageGallery = !this.imageGallery;
      this.giftGallery = false;
      if (this.imageGallery) {
        this.$nextTick(() => {
          this.$refs.galleries.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      }
    },
    toggleGiftGallery: function () {
      this.giftGallery = !this.giftGallery;
      this.imageGallery = false;
      if (this.giftGallery) {
        this.$nextTick(() => {
          this.$refs.galleries.scrollIntoView({ block: 'center', behavior: 'smooth' });
        });
      }
    },
    updateResponsive() {
      this.isMobile = window.innerWidth < 900;
    },
    chatActionMixinMounted() {
      this.updateResponsive();

      window.addEventListener('resize', ev => {
        if (ev.isTrusted) this.updateResponsive();
      });
    }
  },
  mounted() {
  },
  beforeDestroy() {

  }
};
